module.exports = __webpack_public_path__ + "media/rhythm2.86ab2c5c.wav";